// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useContext, Fragment } from 'react';
import cn from 'classnames';
import { Trans as T, useTranslation } from 'react-i18next';
import cookie from 'cookie';
import etask from '/util/etask.js';
import www_util from '../util.js';
import country_util from '/util/country.js';
import { App_context } from '../context.js';
import { search_in_google } from '../ui/search_in_google.ts';
import { img_url } from '../ui/img_url.ts';
import { use_search } from '../ui/use_search';
import { Popular_sitepics } from '../unblock/popular_sitepics.js';
import { Tooltip } from '../lib/tooltip.js';
import { Checkbox } from '../lib/checkbox';
import be from '../be.js';
import styles from './top_sites.module.less';
var Disclaimer = () => /*#__PURE__*/React.createElement("div", {
  className: "container article disclamer"
}, /*#__PURE__*/React.createElement("article", null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T, {
  i18nKey: "unblock_disclaimer"
}), " ", /*#__PURE__*/React.createElement("a", {
  className: "anchor-text",
  href: "/legal/dmca"
}, /*#__PURE__*/React.createElement(T, null, "Hola's DMCA Agent")), ".")));
var Top_sites = props => {
  useTranslation();
  var ctx = useContext(App_context) || {};
  var inited = props.inited || ctx.inited;
  var country_name = props.country_name,
    user_country = props.user_country,
    promotions = props.promotions,
    add_on_scroll = props.add_on_scroll,
    search = props.search,
    user_content = props.user_content,
    sitepics_only = props.sitepics_only,
    cls = props.cls,
    col_gap = props.col_gap,
    row_gap = props.row_gap,
    with_column = props.with_column,
    overlay_cnt = props.overlay_cnt,
    no_empty = props.no_empty,
    scale = props.scale;
  var _ref = search || use_search(props),
    filter = _ref.filter,
    sitepics = _ref.sitepics,
    activate = _ref.activate,
    active = _ref.active,
    set_adult_content = _ref.set_adult_content,
    rule_ratings = _ref.rule_ratings;
  var on_click_google = () => {
    etask(function* () {
      // wait up to 500ms to let perr be sent
      this.spawn(etask.sleep(500));
      this.spawn(be.perr({
        id: 'www_popular_search_click_google',
        info: {
          filter
        }
      }));
      yield this.wait_child('any');
      search_in_google(filter);
    });
  };
  var _useState = useState(props.limit || 35),
    _useState2 = _slicedToArray(_useState, 2),
    limit = _useState2[0],
    set_limit = _useState2[1];
  var on_get_more = event => {
    event && event.preventDefault();
    set_limit(sitepics.matches.length + 1);
  };
  var country = country_name || user_country && country_util.code2label(user_country);
  var style = inited ? {} : {
    maxHeight: '100vh',
    opacity: 0,
    overflow: 'hidden',
    visibility: 'hidden'
  };
  var is_adult = cookie.get && cookie.get('adult_content') || undefined;
  var _useState3 = useState(!is_adult),
    _useState4 = _slicedToArray(_useState3, 2),
    safe_content = _useState4[0],
    set_safe_content = _useState4[1];
  var set_is_adult = value => {
    if (!value) {
      www_util.perr({
        id: `www_popular_safe_content_disable`
      });
      cookie.set('adult_content', 1, {
        min: 3600
      });
    } else {
      www_util.perr({
        id: `www_popular_safe_content_enable`
      });
      cookie.remove('adult_content');
    }
    set_adult_content(!value);
    set_safe_content(value);
  };
  if (no_empty && (rule_ratings || []).length == 0) return /*#__PURE__*/React.createElement(Fragment, null);
  return sitepics_only ? /*#__PURE__*/React.createElement(Popular_sitepics, {
    sitepics: sitepics.matches,
    promotions: promotions,
    active: active,
    activate: activate,
    limit: limit,
    filter: filter,
    with_column: with_column,
    on_get_more: props.on_get_more || on_get_more,
    scale: scale,
    add_on_scroll: add_on_scroll,
    cols_count: props.cols_count,
    row_gap: row_gap,
    col_gap: col_gap,
    cls: cls
  }) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.page, cls)
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.top_sites, styles.container),
    style: style
  }, sitepics.google && /*#__PURE__*/React.createElement("div", {
    className: "search-in-google"
  }, /*#__PURE__*/React.createElement("h3", null, "No matching sites. ", /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: on_click_google
  }, "Google ", /*#__PURE__*/React.createElement("span", {
    className: "search-text"
  }, " \"", filter, "\" "))), /*#__PURE__*/React.createElement("br", null)), !sitepics.google && /*#__PURE__*/React.createElement(Popular_sitepics, {
    sitepics: sitepics.matches,
    promotions: promotions,
    active: active,
    activate: activate,
    limit: limit,
    filter: filter,
    row_gap: row_gap,
    col_gap: col_gap,
    on_get_more: props.on_get_more || on_get_more,
    scale: scale,
    add_on_scroll: add_on_scroll,
    cols_count: props.cols_count,
    header: /*#__PURE__*/React.createElement("div", {
      className: cn(styles.header)
    }, /*#__PURE__*/React.createElement("h2", {
      className: styles.popular_title
    }, "Top sites in ", /*#__PURE__*/React.createElement("span", {
      className: "country"
    }, country)), user_content && /*#__PURE__*/React.createElement("h3", null, "(User generated content)"), /*#__PURE__*/React.createElement("div", {
      className: styles.popular_sites__settings
    }, ctx.is_client && /*#__PURE__*/React.createElement(Tooltip, {
      hover_mode: true,
      cls_cn: "popular_sites__tooltip",
      ref_origin: "www_popular_safe_content",
      content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
        checked: safe_content,
        size: 'sm',
        on_change: set_is_adult,
        caption: "Safe content"
      }))
    }, /*#__PURE__*/React.createElement("img", {
      src: img_url('ic_settings2.svg'),
      className: cn('popular_sites__icon', 'lazyload'),
      alt: "ic_settings"
    })))),
    with_column: with_column
  })), overlay_cnt && overlay_cnt()), !props.hide_disclaimer && limit > sitepics.matches.length && /*#__PURE__*/React.createElement(Disclaimer, null));
};
export { Top_sites };